export const HELLO_EMAIL = 'hello@cfahub.ru';
export const PR_EMAIL = 'pr@cfahub.ru';
export const ASK_EMAIL = 'ask@cfahub.ru';
export const PARTNER_EMAIL = 'partner@cfahub.ru';
export const OPERATOR_EMAIL = 'operator@cfahub.ru';

export const LANDING_DOMAIN_PATH = 'landing-dfa';
export const TELEGRAM_LINK = 'https://t.me/cfa_hub';
